export default [
  {
    id: `retention-interval14`,
    expectedGlobalMessage: `Day 14 retention from Mobile App Open -> Level Completed is 45% lower than expected.`,
    expectedMessages: [
      `Day 14 retention was 40.78% for users from Wednesday, May 4th. This is 45% lower than our forecast of 74.00%.`,
    ],
    alert: {
      alertId: `06a9c222-e1ac-4b12-969b-365dc650bf40`,
      detectionReason: `PROJECT`,
      readAtMs: `1502930674739`,
      ingestedAtMs: `1502929751812`,
      sentFeedbackAtMs: `1502929781812`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `retention-interval14`,
        retentionQuery: {
          segmentMethod: `FIRST`,
          bornEvent: `$custom_event:173179`,
          propertyFilters: [],
          bornPropertyFilters: [],
          dateRange: {
            to: `2016-05-18`,
            from: `2016-04-04`,
          },
          retentionType: `BIRTH`,
          countType: `PERCENT`,
          timeUnit: `DAY`,
          event: `Level Completed`,
          bornEventDisplayName: `Mobile App Open`,
          eventDisplayName: `Level Completed`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `0ef2fb1e-a031-4914-a2ed-663ab8bbb524`,
            direction: `NEGATIVE`,
            retentionDetails: {
              interval: 14,
            },
            valueAtTimestamp: 0.4078,
            anomalyTimestamp: `1463554800000`,
            expectedValue: 0.7400086426983025,
            sentFeedbackAtMs: `1502929781812`,
          },
        ],
      },
    },
  },
  {
    id: `retention-interval56`,
    expectedGlobalMessage: `Day 56 retention from App Session -> App Session is 31% higher than expected.`,
    expectedMessages: [
      `Day 56 retention was 35.35% for users from Friday, May 13th. This is 31% lower than our forecast of 50.90%.`,
    ],
    alert: {
      alertId: `05c6b45a-aad9-4145-8205-0e8e522771f3`,
      detectionReason: `USER`,
      readAtMs: `1502930674749`,
      ingestedAtMs: `1502929751794`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `retention-interval56`,
        retentionQuery: {
          segmentMethod: `FIRST`,
          bornEvent: `$ae_session`,
          propertyFilters: [],
          bornPropertyFilters: [],
          dateRange: {
            to: `2016-07-08`,
            from: `2016-04-13`,
          },
          retentionType: `BIRTH`,
          countType: `PERCENT`,
          timeUnit: `DAY`,
          event: `$ae_session`,
          bornEventDisplayName: `App Session`,
          eventDisplayName: `App Session`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `f3ffa62c-00d3-478d-a3bb-f9b20616bea0`,
            direction: `POSITIVE`,
            retentionDetails: {
              interval: 56,
            },
            valueAtTimestamp: 0.3535,
            anomalyTimestamp: `1467961200000`,
            expectedValue: 0.5090444087929245,
          },
        ],
      },
    },
  },
  {
    id: `funnel-oc-partial`,
    expectedGlobalMessage: `The overall conversion rate for your funnel, Nihar Gaming Funnel, is currently 39% higher than expected.`,
    expectedMessages: [
      `The overall conversion rate is currently 78.69%. This is 39% higher than our forecast of 56.64% for users who entered your funnel on Monday, July 17th.`,
    ],
    alert: {
      alertId: `690eb394-66f5-4730-861c-36662d4c2096`,
      detectionReason: `TOP_EVENTS`,
      readAtMs: `1502930674745`,
      ingestedAtMs: `1502929751712`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-oc-partial`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-17`,
            from: `2017-06-17`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: true,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `8beb5443-6b2b-4818-af40-4293551ecaf7`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: true,
            },
            valueAtTimestamp: 0.7869,
            anomalyTimestamp: `1500274800000`,
            expectedValue: 0.5664392721804936,
          },
        ],
      },
    },
  },
  {
    id: `funnel-oc-full`,
    expectedGlobalMessage: `The overall conversion rate for your funnel, Nihar Gaming Funnel, is 5% lower than expected.`,
    expectedMessages: [
      `The overall conversion rate has decreased to 37.00% for users who entered your funnel on Friday, June 30th. This is 5% lower than our forecast of 38.90%.`,
    ],
    alert: {
      alertId: `ecaae32f-9ccd-41cb-8911-fab0751f1244`,
      detectionReason: `USER`,
      readAtMs: `1502930674748`,
      ingestedAtMs: `1502929751544`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-oc-full`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-06-30`,
            from: `2017-05-31`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: false,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `cf26d493-71db-412d-ac9f-48d57df9720c`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: true,
            },
            valueAtTimestamp: 0.37,
            anomalyTimestamp: `1498806000000`,
            expectedValue: 0.3889740331544943,
          },
        ],
      },
    },
  },
  {
    id: `funnel-step8-full`,
    expectedGlobalMessage: `Conversion for a step in your funnel, Test, is 187% higher than expected.`,
    expectedMessages: [
      `Conversion for this step has increased to 65.33% for users who entered your funnel on Thursday, July 13th. This is 187% higher than our forecast of 22.78%.`,
    ],
    alert: {
      alertId: `521be33b-aa9a-4797-aff2-9897e0c703e6`,
      detectionReason: `USER`,
      readAtMs: `1502930674747`,
      ingestedAtMs: `1502929751542`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-step8-full`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-13`,
            from: `2017-06-13`,
          },
          bookmarkId: 1443695,
          propertyFilters: [],
          isPartial: false,
          funnelName: `Test`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `e9f349ab-8f34-4cd3-936d-30450f735b3f`,
            direction: `POSITIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 7,
            },
            valueAtTimestamp: 0.6533,
            anomalyTimestamp: `1499929200000`,
            expectedValue: 0.22775105197342094,
          },
        ],
      },
    },
  },
  {
    id: `funnel-step1-partial`,
    expectedGlobalMessage: `Conversion for a step in your funnel, Nihar Gaming Funnel, is currently 8% lower than expected.`,
    expectedMessages: [
      `Conversion for this step is currently 74.92%. This is 8% lower than our forecast of 81.46% for users who entered your funnel on Saturday, July 15th.`,
    ],
    alert: {
      alertId: `206a6c1e-84f0-4624-bab2-b687fab66a31`,
      detectionReason: `USER`,
      readAtMs: `1502930674742`,
      ingestedAtMs: `1502929751541`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-step1-partial`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-15`,
            from: `2017-06-15`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: true,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `f5d8aa5b-928a-4d0c-bc6f-445f5c917aea`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 0,
            },
            valueAtTimestamp: 0.7492,
            anomalyTimestamp: `1500102000000`,
            expectedValue: 0.8145697547456785,
          },
        ],
      },
    },
  },
  {
    id: `insights-hour-unique`,
    expectedGlobalMessage: `All Events was 415% higher than usual. The actual value is 839 users, which is higher than our forecast of 163.`,
    expectedMessages: [
      `All Events was 415% higher than usual on Sunday, July 16th at 8pm. The actual value is 839 users, which is higher than our forecast of 163.`,
    ],
    alert: {
      alertId: `66d2e2b2-7cc8-4ded-b3c3-12abf3293599`,
      detectionReason: `USER`,
      readAtMs: `1502930674747`,
      ingestedAtMs: `1502929751525`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-hour-unique`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `HOUR`,
          dateRange: {
            to: `2017-07-16`,
            from: `2017-07-12`,
          },
          showClauses: [
            {
              showEvent: {
                event: `$all_events`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `$all_events`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            alertDetailId: `6a108442-00a2-4bcd-bca3-fca67d4a3ef8`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `UNIQUE`,
            },
            valueAtTimestamp: 839,
            anomalyTimestamp: `1500235200000`,
            expectedValue: 163,
          },
        ],
      },
    },
  },
  {
    id: `insights-hour-grouped`,
    expectedGlobalMessage: `Character Created was 133% higher than usual. The actual value is 745 users, which is higher than our forecast of 320.`,
    expectedMessages: [
      `Character Created was 133% higher than usual on Sunday, July 16th at 8pm. The actual value is 745 users, which is higher than our forecast of 320.`,
      `Character Created was 200% higher than usual on Sunday, July 16th at 8pm. The actual value is 1,231, which is higher than our forecast of 411.`,
    ],
    alert: {
      alertId: `184c49a5-4c1e-4cbd-9e2d-5f86e99215c4`,
      detectionReason: `USER`,
      readAtMs: `1502930674737`,
      ingestedAtMs: `1502929751523`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-hour-grouped`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `HOUR`,
          dateRange: {
            to: `2017-07-16`,
            from: `2017-07-12`,
          },
          showClauses: [
            {
              showEvent: {
                event: `Character Created`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `Character Created`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            anomalyDetailId: `df35087e-bf14-47b2-9962-7e2d04b46442`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `UNIQUE`,
            },
            valueAtTimestamp: 745,
            anomalyTimestamp: `1500235200000`,
            expectedValue: 320,
            explains: [
              {
                priority: 0.7,
                propertySegmentsDetail: {
                  property: `$city`,
                  propertyType: `STRING`,
                  stringValue: `San Francisco`,
                },
                explainType: `PROPERTY_SEGMENTS`,
              },
            ],
          },
          {
            anomalyDetailId: `fa6af7bd-58be-4894-846a-fd1af324b510`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `TOTAL`,
            },
            valueAtTimestamp: 1231,
            anomalyTimestamp: `1500235200000`,
            expectedValue: 411,
          },
        ],
      },
    },
  },
  {
    id: `retention-grouped`,
    expectedGlobalMessage: `The retention rate from Mobile App Open -> Level Completed for multiple time windows have changed.`,
    expectedMessages: [
      `Day 7 retention was 42.57% for users from Sunday, May 1st. This is 39% lower than our forecast of 69.95%.`,
      `Day 14 retention was 40.48% for users from Sunday, April 24th. This is 30% lower than our forecast of 57.64%.`,
    ],
    alert: {
      alertId: `644bb033-7b9c-47fd-ab91-c0376bd10faa`,
      detectionReason: `USER`,
      readAtMs: `1502930674736`,
      ingestedAtMs: `1502929751260`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `retention-grouped`,
        retentionQuery: {
          segmentMethod: `FIRST`,
          bornEvent: `$custom_event:173179`,
          propertyFilters: [],
          bornPropertyFilters: [],
          dateRange: {
            to: `2016-05-08`,
            from: `2016-04-01`,
          },
          retentionType: `BIRTH`,
          countType: `PERCENT`,
          timeUnit: `DAY`,
          event: `Level Completed`,
          bornEventDisplayName: `Mobile App Open`,
          eventDisplayName: `Level Completed`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `f219260e-676d-41dc-8a1c-fe6c55bf9f67`,
            direction: `NEGATIVE`,
            retentionDetails: {
              interval: 7,
            },
            valueAtTimestamp: 0.4257,
            anomalyTimestamp: `1462690800000`,
            expectedValue: 0.6994699607829856,
          },
          {
            anomalyDetailId: `56ba1822-5bc8-4c14-8afa-0d208a7e9d29`,
            direction: `POSITIVE`,
            retentionDetails: {
              interval: 14,
            },
            valueAtTimestamp: 0.4048,
            anomalyTimestamp: `1462690800000`,
            expectedValue: 0.5764368966282959,
          },
        ],
      },
    },
  },
  {
    id: `retention-anything-interval7`,
    expectedGlobalMessage: `Day 7 retention from Anything -> Anything is 85% higher than expected.`,
    expectedMessages: [
      `Day 7 retention was 12.80% for users from Sunday, May 1st. This is 85% lower than our forecast of 84.56%.`,
    ],
    alert: {
      alertId: `e3ba5a45-fc80-48a4-8004-84a5c710d669`,
      detectionReason: `USER`,
      readAtMs: `1502930674739`,
      ingestedAtMs: `1502929751191`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `retention-anything-interval7`,
        retentionQuery: {
          segmentMethod: `FIRST`,
          propertyFilters: [],
          bornPropertyFilters: [],
          dateRange: {
            to: `2016-05-08`,
            from: `2016-04-01`,
          },
          retentionType: `COMPOUNDED`,
          countType: `PERCENT`,
          timeUnit: `DAY`,
          event: `$mp_anything_event`,
          eventDisplayName: `Anything`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `a59ce75d-e24e-4e66-b3fa-9e607a18a861`,
            direction: `POSITIVE`,
            retentionDetails: {
              interval: 7,
            },
            valueAtTimestamp: 0.128,
            anomalyTimestamp: `1462690800000`,
            expectedValue: 0.8456030892835782,
          },
        ],
      },
    },
  },
  {
    id: `retention-interval7`,
    expectedGlobalMessage: `Day 7 retention from Level Completed -> Level Completed is 45% higher than expected.`,
    expectedMessages: [
      `Day 7 retention was 41.64% for users from Thursday, May 12th. This is 45% lower than our forecast of 76.20%.`,
    ],
    alert: {
      alertId: `27aa64ba-9c88-46ae-a5d5-977bcabd0df1`,
      detectionReason: `USER`,
      readAtMs: `1502930674745`,
      ingestedAtMs: `1502929751098`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `retention-interval7`,
        retentionQuery: {
          segmentMethod: `FIRST`,
          bornEvent: `Level Completed`,
          propertyFilters: [],
          bornPropertyFilters: [],
          dateRange: {
            to: `2016-05-19`,
            from: `2016-04-12`,
          },
          retentionType: `BIRTH`,
          countType: `PERCENT`,
          timeUnit: `DAY`,
          event: `Level Completed`,
          bornEventDisplayName: `Level Completed`,
          eventDisplayName: `Level Completed`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `864b2197-f00b-4215-8414-40fad909e562`,
            direction: `POSITIVE`,
            retentionDetails: {
              interval: 7,
            },
            valueAtTimestamp: 0.4164,
            anomalyTimestamp: `1463641200000`,
            expectedValue: 0.7620387685095099,
          },
        ],
      },
    },
  },
  {
    id: `funnel-grouped`,
    expectedGlobalMessage: `The conversion rates for multiple steps in your funnel, Nihar Gaming Funnel, have changed.`,
    expectedMessages: [
      `Conversion for this step is currently 83.46%. This is 736% higher than our forecast of 9.98% for users who entered your funnel on Wednesday, July 12th.`,
      `Conversion for this step is currently 85.30%. This is 47% higher than our forecast of 57.88% for users who entered your funnel on Wednesday, July 12th.`,
    ],
    alert: {
      alertId: `082ea4b5-f12b-4904-a4ca-577d0828f8b4`,
      detectionReason: `USER`,
      readAtMs: `1502930674736`,
      ingestedAtMs: `1502929751004`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-grouped`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-12`,
            from: `2017-06-12`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: true,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `5a5e90af-0a6d-45d8-aa09-92b4d1bc4551`,
            direction: `POSITIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 0,
            },
            valueAtTimestamp: 0.8346,
            anomalyTimestamp: `1499842800000`,
            expectedValue: 0.09979391822825179,
          },
          {
            anomalyDetailId: `fa6d7589-aa30-4908-bb76-7f8282a13e78`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 1,
            },
            valueAtTimestamp: 0.853,
            anomalyTimestamp: `1499842800000`,
            expectedValue: 0.578754769998316,
          },
        ],
      },
    },
  },
  {
    id: `insights-day-grouped`,
    expectedGlobalMessage: `Session End was 1,479% higher than usual. The actual value is 8,368 users, which is higher than our forecast of 530.`,
    expectedMessages: [
      `Session End was 1,479% higher than usual on Saturday, July 15th. The actual value is 8,368 users, which is higher than our forecast of 530.`,
      `Session End was 5,750% higher than usual on Saturday, July 15th. The actual value is 14,449, which is higher than our forecast of 247.`,
    ],
    alert: {
      alertId: `188bee48-d95d-42e5-b0c1-512d82cdfde5`,
      detectionReason: `USER`,
      readAtMs: `1502930674732`,
      ingestedAtMs: `1502929750933`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-day-grouped`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-15`,
            from: `2017-06-15`,
          },
          showClauses: [
            {
              showEvent: {
                event: `Session End`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `Session End`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            anomalyDetailId: `4213dc42-72ee-4bf3-acf2-bb2f81ea1500`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `UNIQUE`,
            },
            valueAtTimestamp: 8368,
            anomalyTimestamp: `1500102000000`,
            expectedValue: 530,
          },
          {
            anomalyDetailId: `a63c4e2c-9357-4fbc-8c6e-16467e113475`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `TOTAL`,
            },
            valueAtTimestamp: 14449,
            anomalyTimestamp: `1500102000000`,
            expectedValue: 247,
          },
        ],
      },
    },
  },
  {
    id: `funnel-step2-partial`,
    expectedGlobalMessage: `Conversion for a step in your funnel, Nihar Gaming Funnel, is currently 28% higher than expected.`,
    expectedMessages: [
      `Conversion for this step is currently 82.60%. This is 28% higher than our forecast of 64.70% for users who entered your funnel on Thursday, July 13th.`,
    ],
    alert: {
      alertId: `177c0665-4a8f-44ea-82ec-451ca65de34a`,
      detectionReason: `USER`,
      readAtMs: `1502930674743`,
      ingestedAtMs: `1502929750823`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-step2-partial`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-13`,
            from: `2017-06-13`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: true,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `29719b0c-d7d2-4f4a-a631-bde2838e38d4`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 1,
            },
            valueAtTimestamp: 0.826,
            anomalyTimestamp: `1499929200000`,
            expectedValue: 0.6470297289861507,
          },
        ],
      },
    },
  },
  {
    id: `insights-day-unique`,
    expectedGlobalMessage: `Level Completed was 789% higher than usual. The actual value is 7,938 users, which is higher than our forecast of 893.`,
    expectedMessages: [
      `Level Completed was 789% higher than usual on Saturday, July 15th. The actual value is 7,938 users, which is higher than our forecast of 893.`,
    ],
    alert: {
      alertId: `0cbbd979-b3ea-4e97-951e-c4cc8dd0d9e8`,
      detectionReason: `USER`,
      readAtMs: `1502930674739`,
      ingestedAtMs: `1502929750805`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-day-unique`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-15`,
            from: `2017-06-15`,
          },
          showClauses: [
            {
              showEvent: {
                event: `Level Completed`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `Level Completed`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            anomalyDetailId: `96f3258d-0216-43a0-915d-2245b46a07f8`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `UNIQUE`,
            },
            valueAtTimestamp: 7938,
            anomalyTimestamp: `1500102000000`,
            expectedValue: 893,
          },
        ],
      },
    },
  },
  {
    id: `funnel-step1-full`,
    expectedGlobalMessage: `Conversion for a step in your funnel, Nihar Gaming Funnel, is 15% lower than expected.`,
    expectedMessages: [
      `Conversion for this step has decreased to 83.30% for users who entered your funnel on Friday, June 30th. This is 15% lower than our forecast of 97.48%.`,
    ],
    alert: {
      alertId: `c528e0d8-961c-4b56-b667-901b25463294`,
      detectionReason: `USER`,
      readAtMs: `1502930674744`,
      ingestedAtMs: `1502929750732`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `funnel-step1-full`,
        funnelsQuery: {
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-06-30`,
            from: `2017-05-31`,
          },
          bookmarkId: 2649662,
          propertyFilters: [],
          isPartial: false,
          funnelName: `Nihar Gaming Funnel`,
        },
        anomalyDetails: [
          {
            anomalyDetailId: `39bcbd2d-fc74-41c4-9bed-8994ff9e9c2d`,
            direction: `NEGATIVE`,
            funnelsDetails: {
              isOverallConversion: false,
              startStepIdx: 0,
            },
            valueAtTimestamp: 0.833,
            anomalyTimestamp: `1498806000000`,
            expectedValue: 0.9747865626266444,
          },
        ],
      },
    },
  },
  {
    id: `insights-hour-total`,
    expectedGlobalMessage: `In-App Purchase was 55% higher than usual. The actual value is 566, which is higher than our forecast of 365.`,
    expectedMessages: [
      `In-App Purchase was 55% higher than usual on Sunday, July 16th at 9pm. The actual value is 566, which is higher than our forecast of 365.`,
    ],
    alert: {
      alertId: `1a9c7165-9fe5-479b-8d0d-6ef73fdd503e`,
      detectionReason: `USER`,
      readAtMs: `1502930674744`,
      ingestedAtMs: `1502929750679`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-hour-total`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `HOUR`,
          dateRange: {
            to: `2017-07-16`,
            from: `2017-07-12`,
          },
          showClauses: [
            {
              showEvent: {
                event: `In-App Purchase`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `In-App Purchase`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            anomalyDetailId: `d908fa7c-cb5b-42e7-b63b-129661f3cece`,
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `TOTAL`,
            },
            valueAtTimestamp: 566,
            anomalyTimestamp: `1500238800000`,
            expectedValue: 365,
          },
        ],
      },
    },
  },
  {
    id: `insights-day-total`,
    expectedGlobalMessage: `Game Played was 3,760% higher than usual. The actual value is 35,327, which is higher than our forecast of 915.`,
    expectedMessages: [
      `Game Played was 3,760% higher than usual on Saturday, July 15th. The actual value is 35,327, which is higher than our forecast of 915.`,
    ],
    alert: {
      alertId: `b6d4380b-bc57-44d2-a4ae-dc8cd2b0f921`,
      detectionReason: `USER`,
      readAtMs: `1502930674746`,
      ingestedAtMs: `1502929750435`,
      isAlertOwner: true,
      anomaly: {
        anomalyId: `insights-day-total`,
        insightsQuery: {
          groupByProperties: [],
          timeUnit: `DAY`,
          dateRange: {
            to: `2017-07-15`,
            from: `2017-06-15`,
          },
          showClauses: [
            {
              showEvent: {
                event: `Game Played`,
              },
            },
          ],
          propertyFilters: [],
          eventDisplayName: `Game Played`,
          propertySegments: [],
        },
        anomalyDetails: [
          {
            direction: `POSITIVE`,
            insightsDetails: {
              showAction: `TOTAL`,
            },
            valueAtTimestamp: 35327,
            anomalyTimestamp: `1500102000000`,
            expectedValue: 915.147862111038,
          },
        ],
      },
    },
  },
];
